import { render, staticRenderFns } from "./adminShop.vue?vue&type=template&id=be3d0fd2"
import script from "./adminShop.vue?vue&type=script&lang=js"
export * from "./adminShop.vue?vue&type=script&lang=js"
import style0 from "./adminShop.vue?vue&type=style&index=0&id=be3d0fd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports